import React from 'react'

export default function TableCell(props) {
  return (
    <div className={'d-flex align-items-center fs-16 sm-fs-14 color-3a3335 ph-10 sm-ph-5 ' + props.className} 
    onClick={props.onClick}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
    >
      {
        props.child === null &&
        <div className={props.center === false ? 'w-100' : 'w-100 text-center'} style={{color : props.color || "inherit"}}>{props.value}</div>
      }
      {
        props.child !== null &&
        props.child
      }
    </div>
  )
}


export function TableCellNoColor(props) {
  return (
    <div className={'d-flex align-items-center fs-16 sm-fs-14 ph-10 sm-ph-5 ' + props.className} 
    onClick={props.onClick}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
    >
      {
        props.child === null &&
        <div className={props.center === false ? 'w-100' : 'w-100 text-center'} style={{color : props.color || "inherit"}}>{props.value}</div>
      }
      {
        props.child !== null &&
        props.child
      }
    </div>
  )
}